import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import { resetUserSettings } from "../../../services/userService";
import { finishSmokingHistory, pathRoot } from "../SmokingHistory";
import { Checkbox } from "../../../components/common/FormInputs";

export function Page1({ smokingHistory }) {
	const schema = {
		type: "object",
	};

	const [smoker, setSmoker] = useState(smokingHistory.smoker);

	const onClickNext = () => {
		smokingHistory.smoker = smoker;

		if (smoker === 2) {
			smokingHistory.smokingDuration = null;
			smokingHistory.smokingTypes = [];
			smokingHistory.cigaretteAmount = null;
			return finishSmokingHistory(smokingHistory);
		} else {
			return finishSmokingHistory();
		}
	};

	const nextTextOverride = () => {
		if (smoker === 2) {
			return "Finish";
		}

		return "Next";
	};

	const nextTo = () => {
		if (smoker === 2) {
			return setupData;
		}

		return `${pathRoot}/2`;
	};

	const headerDetails = {
		title: "Smoking History",
		currentPage: 1,
		pageCount: 2,
	};

	const isChecked = (value) => {
		return smoker === value;
	};

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={setupData}
				nextTo={nextTo()}
				onClickBack={resetUserSettings}
				onClickNext={{ func: onClickNext, async: true }}
				hideNext={smoker === null}
				nextTextOverride={nextTextOverride()}
			>
				<Form schema={schema}>
					<p className={"text-lg sm:text-xl font-bold mb-6"}>
						Are you a smoker or have you ever been one?
					</p>

					<Field
						type="radio"
						name="smoker"
						id="current"
						className={"hidden"}
						value={"current"}
						checked={smoker === 0}
						onClick={() => setSmoker(0)}
					/>
					<Checkbox
						htmlFor={"current"}
						label={"Yes, current smoker"}
						checked={isChecked(0)}
					/>

					<Field
						type="radio"
						name="smoker"
						id="former"
						className={"hidden"}
						value={"former"}
						checked={smoker === 1}
						onClick={() => setSmoker(1)}
					/>
					<Checkbox
						htmlFor={"former"}
						label={"Yes, former smoker"}
						checked={isChecked(1)}
					/>

					<Field
						type="radio"
						name="smoker"
						id="never"
						className={"hidden"}
						value={"never"}
						checked={smoker === 2}
						onClick={() => setSmoker(2)}
					/>
					<Checkbox
						htmlFor={"never"}
						label={"No, never smoked"}
						checked={isChecked(2)}
					/>
				</Form>
			</SetupDataPageTemplate>
		</>
	);
}
